import styled from "styled-components";

import { color } from "../helpers/constants";

const Link = styled.a`
  color: ${color.black};
  text-decoration: underline;
`;

export default Link;
